import React from 'react';
import styled from 'styled-components';
import { inputValidation, onBlurValidation } from '../../../../utils/CBGUInputValidations';

const PortionInputs = ({ minWeigth, weight, maxWeigth, handleInput }) => {
  return (
    <PortionBlock>
      <PortionItem>
        <Label htmlFor="carbohydrates">
          Минимальная порция<Message>*</Message>
        </Label>
        <PortionValueInput
          placeholder="Минимальная порция"
          name="minWeigth"
          value={minWeigth}
          onInput={inputValidation}
          onBlur={(e) => onBlurValidation(e, handleInput)}
          onChange={(e) => handleInput(e, 'portion', 'minWeigth')}
        />
      </PortionItem>
      <PortionItem>
        <Label htmlFor="carbohydrates">
          Средняя порция<Message>*</Message>
        </Label>
        <PortionValueInput
          placeholder="Средняя порция"
          name="weight"
          value={weight}
          onInput={inputValidation}
          onBlur={(e) => onBlurValidation(e, handleInput)}
          onChange={(e) => handleInput(e, 'portion', 'weight')}
        />
      </PortionItem>
      <PortionItem>
        <Label htmlFor="carbohydrates">
          Максимальная порция<Message>*</Message>
        </Label>
        <PortionValueInput
          placeholder="Максимальная порция"
          name="maxWeigth"
          value={maxWeigth}
          onInput={inputValidation}
          onBlur={(e) => onBlurValidation(e, handleInput)}
          onChange={(e) => handleInput(e, 'portion', 'maxWeigth')}
        />
      </PortionItem>
    </PortionBlock>
  );
};

export default PortionInputs;

const PortionBlock = styled.div`
  display: inline-block;
  width: 60%;
  margin: 0 5%;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

const PortionItem = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 5px 0;
  @media (max-width: 580px) {
    flex-wrap: wrap;
  }
`;

const Label = styled.label`
  display: inline-block;
  text-align: center;
  @media (max-width: 768px) {
    text-align: left;
    width: 35%;
  }
  @media (max-width: 580px) {
    margin-bottom: 10px;
    width: 100%;
  }
`;

const PortionValueInput = styled.input`
  display: inline-block;
  height: 30px;
  width: 50%;
  text-align: center;
  @media (max-width: 768px) {
    width: 60%;
  }
  @media (max-width: 580px) {
    margin-bottom: 10px;
    width: 100%;
  }
`;

const Message = styled.span`
  display: inline-block;
  color: #ea1b00;
  margin: 0 3px;
`;



// WEBPACK FOOTER //
// ./src/Components/Dishes/Popups/Dish/PortionInputs.jsx